import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectOnboardingInterestWizardCancelUrl,
  selectOnboardingInterestWizardDonelUrl,
} from '../store/selectors/onboarding-config.selectors';
import { NativeClientService } from '@shared/services/native-client.service';

export type StepId = 'partner' | 'two-factor-auth';

@Injectable({
  providedIn: 'root',
})
export class InterestWizardService {
  private steps: StepId[] = ['partner', 'two-factor-auth'];
  private readonly nativeClientService = inject(NativeClientService);
  private readonly store = inject(Store);

  cancelUrl = '/';
  doneUrl = '/';

  constructor() {
    if (!this.nativeClientService.isNative) {
      this.store
        .pipe(selectOnboardingInterestWizardCancelUrl)
        .subscribe((url) => (this.cancelUrl = url));
    }
    this.store
      .pipe(selectOnboardingInterestWizardDonelUrl)
      .subscribe((url) => (this.doneUrl = url));
  }

  getNextStep(step: StepId): StepId | null {
    return this.steps[this.steps.indexOf(step) + 1] || null;
  }
  getPreviousStep(step: StepId): StepId | null {
    return this.steps[this.steps.indexOf(step) - 1] || null;
  }

  getRouteByStepId(step: StepId): string {
    return `/interests/${step}`;
  }
}
